import {i18n} from "translate/i18n";

export const RoutesMenu = [
    {
        path: "#dashboard",
        id: "dashboard",
        name: i18n.t('titlePage.dashboard'),
        icon: 'bi-grid',
        auth: [1,2,3,4,5,6,7],
        subMenu: [
            {
                name: i18n.t('titlePage.indicators'),
                path: '/dashboard/indicators',
                icon: 'bi bi-circle',
                auth: [1,2,3,4,5,6,7],
            },
            {
                name: i18n.t('titlePage.goals'),
                path: '/dashboard/goals',
                icon: 'bi bi-circle',
                auth: [1],
            },
            // {
            //     name: 'Dash',
            //     path: '/dashboard/default',
            //     icon: 'bi bi-circle',
            // }
        ]
    },
    // {
    //     path: '#workflow',
    //     id: "workflow",
    //     name: i18n.t('titlePage.workflow'),
    //     icon: 'bi bi-diagram-3',
    //     auth: [1],
    //     subMenu: [
    //         {
    //             name: i18n.t('titlePage.indicators'),
    //             path: '/workflow/indicators',
    //             icon: 'bi bi-circle',
    //         },
    //         {
    //             name: i18n.t('titlePage.goals'),
    //             path: '/workflow/goals',
    //             icon: 'bi bi-circle',
    //         }
    //     ]
    // },
    // {
    //     path: "/collect/indicators",
    //     name: "Fichas de coleta",
    //     icon: 'bi  bi-card-heading',
    //     auth: [1] ,
    // },

    {
        path: "/tags",
        name: "Tags",
        icon: 'bi bi-tags',
        auth: [1],
    },
    {
        path: "/list",
        name: "Lista de Indicadores",
        icon: 'bi-list-task',
        auth: [1],
    },
    {
        path: "#upload",
        id: "upload",
        name: i18n.t('titlePage.upload'),
        icon: 'bi bi-cloud-upload',
        auth: [1],
        subMenu: [
            {
                name: i18n.t('titlePage.documents'),
                path: '/documents',
                icon: 'bi bi-circle',
                auth: [1],
            },
            {
                name: i18n.t('titlePage.indicators'),
                path: '/upload/indicators',
                icon: 'bi bi-circle',
                auth: [1],
            },
            {
                name: i18n.t('titlePage.goals'),
                path: '/upload/goals',
                icon: 'bi bi-circle',
                auth: [1],
            }
        ]
    },
    {
        path: "/content",
        name: i18n.t('titlePage.content'),
        icon: 'bi bi-pencil-square',
        auth: [1],
    },
    {
        path: "/users/list",
        name: i18n.t('titlePage.users'),
        icon: 'bi bi-people',
        auth: [1],
    },
    {
        path: "/logs",
        name: i18n.t('titlePage.logs'),
        icon: 'bi bi-clock-history',
        auth: [1],
    },
    {
        path: "/admin",
        name: 'Administrativo',
        icon: 'bi bi-person-gear',
        auth: [1],
    },
]
